/*
  Custom PDP heroes post a normal product form and leave for /cart.
  Ghostbed keeps the shopper on the page and opens the cart sheet.
  Dawn product-form and the sticky bar already do their own AJAX.
*/
(function () {
  const SKIP_FORM = '.installment, .tt-product-6011-sticky-atc__form';

  const shouldHandle = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.closest('product-form')) return false;
    if (form.matches(SKIP_FORM)) return false;
    if (!form.querySelector('[name="add"]')) return false;
    const action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  };

  const showError = (form, message) => {
    let error = form.querySelector('[data-tt-cart-add-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'tt-cart-add-error';
      error.setAttribute('data-tt-cart-add-error', '');
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.hidden = !message;
    error.textContent = message || '';
  };

  const drawer = () => document.querySelector('cart-drawer');

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!shouldHandle(form)) return;

      event.preventDefault();
      event.stopPropagation();

      if (form.dataset.ttCartAdding === '1') return;

      const cart = drawer();
      if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      const button = event.submitter || form.querySelector('[name="add"]');
      form.dataset.ttCartAdding = '1';
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('tt-cart-add-pending');
      }
      showError(form, '');

      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      formData.append(
        'sections',
        cart
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (window.ttHandleCappedAdd && window.ttHandleCappedAdd(cart, formData.get('id'), response.description)) return;
            showError(form, response.description || response.message || 'Unable to add to cart');
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'tt-cart-drawer-add',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }

          cart.classList.remove('is-empty');
          cart.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
          showError(form, 'Unable to add to cart');
        })
        .finally(() => {
          delete form.dataset.ttCartAdding;
          if (button) {
            button.removeAttribute('aria-busy');
            button.classList.remove('tt-cart-add-pending');
          }
        });
    },
    true
  );
  document.addEventListener('change', (event) => syncDrawerQtyIcon(event.target));
  document.addEventListener('input', (event) => syncDrawerQtyIcon(event.target));
})();

function syncDrawerQtyIcon(target) {
  if (!(target instanceof HTMLInputElement) || !target.classList.contains('quantity__input')) return;
  const box = target.closest('.tt-cart-qty');
  if (!box || !box.closest('cart-drawer')) return;
  const qty = parseInt(target.value, 10);
  box.classList.toggle('tt-cart-qty--multi', Number.isFinite(qty) && qty > 1);
}

(function () {
  const notice = () => document.querySelector('cart-drawer .tt-cart-notice');
  let pendingOpen = null;

  const plainText = (message) => {
    const el = document.createElement('div');
    el.innerHTML = String(message || '');
    return (el.textContent || '').trim();
  };

  const quantityMessage = (max) =>
    window.cartStrings && window.cartStrings.quantityError
      ? window.cartStrings.quantityError.replace('[quantity]', String(max))
      : `You can only add ${max} of this item to your cart.`;

  const classifyCap = (description) => {
    const text = plainText(description);
    const rule = text.match(/only add\s+(\d+)/i);
    if (rule) {
      const max = parseInt(rule[1], 10);
      if (Number.isFinite(max) && max > 0) return { type: 'rule', max };
    }
    if (/only\s+\d+\s+items?\s+(?:was|were)\s+added/i.test(text)) return { type: 'partial' };
    if (/maximum quantity of this item is already in your cart/i.test(text)) return { type: 'at-max' };
    return null;
  };

  window.ttQuantityCapFrom = (description) => {
    const found = classifyCap(description);
    return found && found.max ? found.max : null;
  };

  const sectionIds = (cart) => cart.getSectionsToRender().map((section) => section.id);

  const loadDrawerSections = () => {
    const cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.getSectionsToRender !== 'function') return Promise.resolve(null);
    const ids = sectionIds(cart).join(',');
    return fetch(`${window.location.pathname}?sections=${encodeURIComponent(ids)}`)
      .then((response) => response.json())
      .then((sections) => ({ sections }));
  };

  const adjustToMax = (cart, variantId, max) => {
    const ids = sectionIds(cart);
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(`${cartUrl}.js`)
      .then((response) => response.json())
      .then((cartData) => {
        const items = cartData.items || [];
        const index = items.findIndex(
          (entry) => String(entry.variant_id) === String(variantId) || String(entry.id) === String(variantId)
        );
        if (index === -1) {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', String(max));
          formData.append('sections', ids.join(','));
          formData.append('sections_url', window.location.pathname);
          return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          }).then((response) => response.json());
        }
        return fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            line: index + 1,
            quantity: max,
            sections: ids,
            sections_url: window.location.pathname,
          }),
        }).then((response) => response.json());
      })
      .then((state) => (state && state.sections ? state : loadDrawerSections()));
  };

  const revealDrawer = () => {
    const cart = document.querySelector('cart-drawer');
    if (!cart) return null;
    cart.classList.remove('is-empty');
    cart.classList.remove('tt-notice-first');
    cart.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return cart;
  };

  const paintDrawer = (cart, state) => {
    if (!cart || !state || !state.sections || typeof cart.renderContents !== 'function') return;
    try {
      cart.renderContents(state);
    } catch (error) {
      console.error(error);
    }
    cart.classList.remove('tt-notice-first');
    cart.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  };

  const lineQuantity = (variantId) => {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(`${cartUrl}.js`)
      .then((response) => response.json())
      .then((cartData) => {
        const item = (cartData.items || []).find(
          (entry) => String(entry.variant_id) === String(variantId) || String(entry.id) === String(variantId)
        );
        return item ? item.quantity : null;
      });
  };

  window.ttHandleCappedAdd = (cart, variantId, description) => {
    const found = classifyCap(description);
    if (!found || !cart || !variantId) return false;
    const drawerCart = document.querySelector('cart-drawer') || cart;
    if (found.type === 'rule') {
      showNotice(quantityMessage(found.max));
      pendingOpen = adjustToMax(drawerCart, variantId, found.max);
      return true;
    }
    pendingOpen = lineQuantity(variantId).then((max) => {
      showNotice(max ? quantityMessage(max) : plainText(description));
      if (!max) return loadDrawerSections();
      return adjustToMax(drawerCart, variantId, max);
    });
    return true;
  };

  window.ttHoldCappedCart = (cart, variantId, max, message) => {
    if (window.ttHandleCappedAdd(cart, variantId, message)) return;
    if (!cart || !variantId || !max) return;
    showNotice(quantityMessage(max));
    pendingOpen = adjustToMax(document.querySelector('cart-drawer') || cart, variantId, max);
  };

  const closeNotice = () => {
    const el = notice();
    if (el) el.hidden = true;
    const job = pendingOpen;
    pendingOpen = null;
    if (!job) {
      document.querySelector('cart-drawer')?.classList.remove('tt-notice-first');
      return;
    }
    const cart = revealDrawer();
    job
      .then((state) => paintDrawer(cart, state))
      .catch((error) => {
        console.error(error);
        revealDrawer();
      });
  };

  const showNotice = (message) => {
    const text = plainText(message);
    if (!text) return;
    const cart = document.querySelector('cart-drawer');
    if (cart && !cart.classList.contains('active')) cart.classList.add('tt-notice-first');
    document.body.classList.add('overflow-hidden');
    document.dispatchEvent(new CustomEvent('tt:cart-notice', { detail: { message: text } }));
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('cart-drawer .tt-cart-qty .quantity__button[name="plus"]');
      if (!button) return;
      const input = button.closest('quantity-input')?.querySelector('.quantity__input');
      if (!input || input.max === '') return;
      const max = parseInt(input.max, 10);
      const current = parseInt(input.value, 10);
      if (!Number.isFinite(max) || !Number.isFinite(current) || current < max) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const message =
        window.cartStrings && window.cartStrings.quantityError
          ? window.cartStrings.quantityError.replace('[quantity]', String(max))
          : `You can only add ${max} of this item to your cart.`;
      showNotice(message);
    },
    true
  );

  document.addEventListener('tt:cart-notice', (event) => {
    const el = notice();
    const text = el && el.querySelector('.tt-cart-notice__text');
    const message = event.detail && event.detail.message;
    if (!el || !text || !message) return;
    text.textContent = message;
    el.hidden = false;
    const ok = el.querySelector('.tt-cart-notice__ok');
    if (ok) ok.focus();
  });

  document.addEventListener(
    'click',
    (event) => {
      const el = notice();
      if (!el || el.hidden) return;
      if (event.target === el || event.target.closest('.tt-cart-notice__ok')) {
        event.preventDefault();
        event.stopPropagation();
        closeNotice();
      }
    },
    true
  );

  document.addEventListener(
    'keyup',
    (event) => {
      const el = notice();
      if (!el || el.hidden || event.key !== 'Escape') return;
      event.stopPropagation();
      closeNotice();
    },
    true
  );
})();
